/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_SavingInputs */

const en_task_saving = /** @type {(inputs: Task_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating…`)
};

const pt_br2_task_saving = /** @type {(inputs: Task_SavingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criando…`)
};

/**
* | output |
* | --- |
* | "Creating…" |
*
* @param {Task_SavingInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_saving = /** @type {((inputs?: Task_SavingInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_SavingInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_saving(inputs)
	return pt_br2_task_saving(inputs)
});